import React, { useRef, useEffect, useState } from "react";
import Plyr from 'plyr'
import VideoEmbed from "./VideoEmbed";
import { pushDatatoAdobeLayer } from '../../../analytics/pmiAdobeLog'
import { getContentDetailsOnClick } from '../../../utils/utility'
const CardVideo = ({ videoFile, brightcove, post }) => {
  const videoRef = useRef(null);

  useEffect(() => {
    // if (!videoRef.current) {
    //   return
    // }
    const player = new Plyr(videoRef.current)
    player.play();
  }, []);
  const [videoPercentage] = useState({
    is25PercentVideoCompleted: false,
    is50PercentVideoCompleted: false,
    is75PercentVideoCompleted: false,
    isUserPlayFirstTime: true
  })
  const getAdobeAnalyticsObject = ({ videoAction, vTime }) => {
    return {
      event: "video", eventInfo: "video",
      action: videoAction,
      video: {
        videoID: post.contentKey,
        videoTitle: post.title,
        videoMetaTags: "",
        videoTime: vTime
      }
    }
  }

  let vId;
  let onVideoData = {}
  let [isUserPlayFirstTime, setisUserPlayFirstTime] = useState(true);

  const videoPlayed = () => {
    vId = document.getElementById(post.id);
    /* capture data on video play button */
    if (isUserPlayFirstTime) {
      onVideoData = getAdobeAnalyticsObject({ videoAction: 'video-play', vTime: vId.currentTime.toFixed(2).toString() })
      pushDatatoAdobeLayer({ pageData: false, adobePushTracking: false, onVideoData })
      getContentDetailsOnClick(post, 'video-play', 'card-content')
      setisUserPlayFirstTime(false)
    }
    /* code ends here for play button */

    vId.addEventListener("timeupdate", function () {
      if (parseInt(this.currentTime) === parseInt(this.duration * .25)) {
        if (!videoPercentage.is25PercentVideoCompleted) {
          onVideoData = getAdobeAnalyticsObject({ videoAction: 'video-25', vTime: this.currentTime.toFixed(2).toString() })
          pushDatatoAdobeLayer({ pageData: false, adobePushTracking: false, onVideoData })
        }
        videoPercentage.is25PercentVideoCompleted = true;
      }

      if (parseInt(this.currentTime) === parseInt(this.duration * .50)) {
        if (!videoPercentage.is50PercentVideoCompleted) {
          onVideoData = getAdobeAnalyticsObject({ videoAction: 'video-50', vTime: this.currentTime.toFixed(2).toString() })
          pushDatatoAdobeLayer({ pageData: false, adobePushTracking: false, onVideoData })
        }
        videoPercentage.is50PercentVideoCompleted = true;
      }

      if (parseInt(this.currentTime) === parseInt(this.duration * .75)) {
        if (!videoPercentage.is75PercentVideoCompleted) {
          onVideoData = getAdobeAnalyticsObject({ videoAction: 'video-75', vTime: this.currentTime.toFixed(2).toString() })
          pushDatatoAdobeLayer({ pageData: false, adobePushTracking: false, onVideoData })
        }
        videoPercentage.is75PercentVideoCompleted = true;
      }
    });

  };
  const videoPause = () => {
    vId = document.getElementById(post.id);
    if (vId.duration > vId.currentTime) {
      onVideoData = getAdobeAnalyticsObject({ videoAction: 'video-pause', vTime: vId.currentTime.toFixed(2).toString() })
      pushDatatoAdobeLayer({ pageData: false, adobePushTracking: false, onVideoData })
      getContentDetailsOnClick(post, 'video-pause', 'card-content')
    }
    setisUserPlayFirstTime(false)
  }

  const videoEnded = () => {
    vId = document.getElementById(post.id);
    onVideoData = getAdobeAnalyticsObject({ videoAction: 'video-complete', vTime: vId.currentTime.toFixed(2).toString() })
    pushDatatoAdobeLayer({ pageData: false, adobePushTracking: false, onVideoData })
    isUserPlayFirstTime = true;
    videoPercentage.is25PercentVideoCompleted = false;
    videoPercentage.is50PercentVideoCompleted = false;
    videoPercentage.is75PercentVideoCompleted = false;
  }
  return (
    <div className="mb-5" adoberegion='card-content'>
      {brightcove() ? (
        <VideoEmbed url={videoFile()} />
      ) : (
        <video ref={videoRef} className="block w-full" controls style={{ '--plyr-color-main': '#ed8936' }}
          id={post.id}
          controlsList='nodownload'
          onPlay={videoPlayed}
          onPause={videoPause}
          onEnded={videoEnded}
        >
          <source src={videoFile()} type="video/mp4" />
        </video>
      )}
    </div>
  );
};

export default CardVideo;
